<template>
  <div class="article-content" :style="articleContent" ref="articleContent">
    <div class="title-box" v-if="isShowTitleBox">
      <p
        class="main-title"
        v-if="receiveProps.tempData.articleContentData.articleTitleStatus"
      >
        {{ articleData.articleTitle }}
      </p>
      <p class="publish-box">
        <span
          class="release-time"
          v-if="receiveProps.tempData.articleContentData.releaseTimeStatus"
        >
          {{ articleData.publishTime }}
        </span>
        <span
          class="obser-num"
          v-if="receiveProps.tempData.articleContentData.readingStatus"
        >
          <img
            src="../asset/images/obser-num-img.png"
            style="width: 14px; height: 14px"
          />{{ articleData.readNum }}
        </span>
      </p>
    </div>
    <div
      class="content-box"
      v-html="articleData && articleData.content"
      v-if="!isVideoArticle && articleData"
    ></div>
    <div class="content-box-video" v-if="isVideoArticle">
      <VideoBox :videoUrl="articleData && articleData.articleVideoUrl" :isAuto="false" />
    </div>
    <div class="article-source" v-if="articleData && articleData.copyrightType==1">
      <p>文章来源: {{ articleData.source }}</p>
      <p>版权归原作者所有，如有侵权请联系我们删除</p>
    </div>
    <div class="articleBottom" v-if="articleData.enclosureJson">
      <div class="articleBottomLeft">
        <div class="fujianItem" v-for="(item, index) in JSON.parse(articleData.enclosureJson)" :key="index" v-show="item.name">
          <div class="fujianItemLeft">
            <p class="fujianTitle fl">附件：</p>
            <p class="yasuobaoTitle fl">
              <span class="ellipsis">{{ item.name }}</span>
            </p>
          </div>
          <div class="fujianItemRight fr">
            <a
              :href="item.url"
              class="fujianDownload"
              target="_blank"
              v-if="suffixFilter(item.name)"
            >预览</a>
            <span class="fujianDownload" v-else @click="handleDownload(item.url,item.name)">下载</span>
          </div>
        </div>

        <div v-show="articleData.externalName" class="fujianItem friendLinkItem">
          <div class="fujianItemLeft">
            <p class="fl">相关链接：</p>
            <p class="yasuobaoTitle articleCountLink fl">
              {{ articleData.externalName }}
            </p>
          </div>
          <div class="fujianItemRight fr">
            <a
              :href="articleData.externalUrl"
              class="lijiqianwang"
              target="_blank"
            >立即前往</a
            >
          </div>
        </div>

      </div>
    </div>
    <div class="placeholder-img" v-if="Object.keys(articleData).length == 0">
      <img src="http://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/10/1635325879805.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "articleContent",
  props: {
    receiveProps: {
      type: [Object, Array],
      default: () => {},
    },
  },
  components: {
    VideoBox: () => import("./components/VideoBannerCom"),
  },
  computed: {
    articleContent() {
      let {
        blockMargeTop,
        blockMargeBottom,
        blockBGClolor,
      } = this.receiveProps.tempData.specialStyle;

      return {
        // 整体区块
        "--all-margin-top": `${blockMargeTop}px`,
        "--all-margin-bottom": `${blockMargeBottom}px`,
        "--all-background-color": blockBGClolor,
      };
    },
  },
  data() {
    return {
      articleData: {},
      isShowTitleBox: true,
      isVideoArticle: false, // 判断视频文章 || 图文文章
    };
  },
  mounted() {
    this.getArticleData();
  },
  methods: {
    getArticleData() {
      let {
        articleTitleStatus,
        releaseTimeStatus,
        readingStatus,
        articleId,
      } = this.receiveProps.tempData.articleContentData;
      if (!articleTitleStatus && !releaseTimeStatus && !readingStatus) {
        this.isShowTitleBox = false;
      } else {
        this.isShowTitleBox = true;
      }

      this.$apipcs.news
        .getArticleInfo({ articleId: articleId,
         readTag: 1,
         pageNum: 1,
         pageSize: 9999})
        .then((res) => {
          this.articleData = res.data.list[0];
          this.isVideoArticle = res.data.list[0].articleType == 2 ? true : false;
        });
    },
    suffixFilter (msg) {
      const suffix = msg.lastIndexOf('.');
      return msg.slice(suffix+1) == 'pdf' ? true : false
    },
    handleDownload(imgUrl,name) {
      fetch(imgUrl, {
        method: "get",
        headers: new Headers({
          Origin: location.origin
        }),
        mode: "cors",
      }).then((res) =>
        res.blob().then((blob) => {
          var reader = new FileReader();
          reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签href
          reader.onload = function (e) {
            var down = document.createElement("a"); // 转换完成，创建一个a标签用于下载
            down.download = name;
            down.href = String(e.target.result);
            down.click();
            down.remove();
          };
        })
      );
    }
  },
};
</script>

<style lang="less" scoped>
@import "../asset/articleDetail.css";
.article-content {
  width: 1200px;
  margin: 0 auto;
  margin-top: var(--all-margin-top);
  margin-bottom: var(--all-margin-bottom);
  background-color: var(--all-background-color);
  .title-box {
    padding: 24px;
    border-bottom: 1px solid #ddd;
    .main-title {
      width: 1152px;
      height: 26px;
      font: 400 18px PingFangSC-Regular, PingFang SC;
      color: #333333;
      line-height: 26px;
      margin-bottom: 8px;
    }
    .release-time {
      height: 20px;
      font: 400 14px PingFangSC-Regular, PingFang SC;
      color: #999999;
      line-height: 20px;
      margin-right: 24px;
    }
    .obser-num {
      height: 20px;
      font: 400 14px  PingFangSC-Regular, PingFang SC;
      color: #666666;
      line-height: 20px;
      display: inline-flex;
      align-items: center;
      img {
        margin-right: 8px;
      }
    }
  }
  .content-box {
    margin-top: 1px;
    padding: 24px;
    width: 1152px;
    box-sizing: border-box;
    font: 400 16px PingFangSC-Regular, PingFang SC;
    color: #333333;
    line-height: 26px;
    // text-indent: 2em; 缩进两字节
  }
  .content-box-video {
    margin-top: 1px;
    width: 1152px;
    font: 400 16px PingFangSC-Regular, PingFang SC;
    color: #333333;
    line-height: 26px;
  }
  .article-source {
    width: 100%;
    display: inline-block;
    font: 400 12px PingFangSC-Regular, PingFang SC;
    color: #999999;
    text-align: left;
    margin: 24px;
  }
  .publish-box {
    display: flex;
    align-items: center;
  }
}
.placeholder-img {
  width: 1200px;
  margin-top: -45px;
  img {
    width: 1200px;
    height: 400px;
  }
}

</style>